export interface CalendarEvent {
  title: string;
  description: string;
  location: string;
  startDate?: Date;
  endDate?: Date;
}

export function generateICSFile(event: CalendarEvent) {
  const start =
    event.startDate instanceof Date && !isNaN(event.startDate.getTime())
      ? event.startDate.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z"
      : "";
  const end =
    event.endDate instanceof Date && !isNaN(event.endDate.getTime())
      ? event.endDate.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z"
      : "";

  if (!start) {
    throw new Error("Invalid or missing start date for the event.");
  }

  const icsData = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "BEGIN:VEVENT",
    `SUMMARY:${event.title}`,
    `DESCRIPTION:${event.description}`,
    `LOCATION:${event.location}`,
    `DTSTART:${start}`,
    end ? `DTEND:${end}` : "",
    "END:VEVENT",
    "END:VCALENDAR",
  ]
    .filter(Boolean)
    .join("\r\n");

  return icsData;
}

export function handleAddToCalendar(event: CalendarEvent) {
  const icsData = generateICSFile(event);
  const blob = new Blob([icsData], { type: "text/calendar;charset=utf-8" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${event.title}.ics`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
